<template>
  <div class="news-container" id="page-news">
    <img
      class="news-title"
      src="https://cdn-game-activity.23you.net/frontend/ddj-official-vietnam/assets/news.png"
      alt=""
    />
    <div class="news-content">
      <div class="house">
        <div class="swiper-container news-swiper-container">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="item in swiperImages"
              :key="item.image"
            >
              <img
                :src="item.image"
                :alt="item.adName"
                @click="handleClickSwiperImage(item.link)"
              />
            </div>
          </div>
          <!-- 如果需要分页器 -->
          <div class="swiper-pagination"></div>
        </div>
        <div class="news-list">
          <div class="news-item">
            <ul>
              <li
                @click="jumpLink('/detail', item)"
                v-for="(item, index) in newsData"
                :key="index"
              >
                <div class="circle"></div>
                <div class="title">{{ item.articleTitle }}</div>
                <div class="date-time">{{ item.deployTime | formatTime }}</div>
              </li>
            </ul>
          </div>
          <div class="news-more" @click="jumpLink('/list')"></div>
        </div>
        <div class="cut-btn">
          <div
            class="cut-item"
            v-for="(item, index) in bottomItems"
            @click="changeItem(item.id)"
            :key="index"
          >
            <img
              v-if="item.id === active_item_id"
              :src="item.bgImageActiveUrl"
              alt=""
              class="cut-item-image nav-item-bgImage--pc"
            />
            <img
              v-else
              :src="item.bgImageUrl"
              alt=""
              class="cut-item-image nav-item-bgImage--pc"
            />
            <img
              v-if="item.id === active_item_id"
              :src="item.bgImageActiveUrlMobile"
              alt=""
              class="cut-item-image nav-item-bgImage--mobile"
            />
            <img
              v-else
              :src="item.bgImageUrlMobile"
              alt=""
              class="cut-item-image nav-item-bgImage--mobile"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="article-bottom-nav">
      <img
        class="article-bottom-nav__item"
        v-for="(item, index) in bottomNavList"
        :key="item.image"
        :src="item.image"
        @click="handleClickBottomNav(item.link, index)"
      />
    </div>
  </div>
</template>
<script>
import { getAd, getArticle, getArticleClass } from '@/api/index.js';
import { jumpUrlNewWindow } from '@/js/common.js';
export default {
  data() {
    return {
      bottomItems: [
        {
          label: '动态',
          value: 'all',
          bgImageUrl:
            'https://cdn-game-activity.23you.net/frontend/ddj-official-vietnam/assets/article-nav-1.png',
          bgImageActiveUrl:
            'https://cdn-game-activity.23you.net/frontend/ddj-official-vietnam/assets/article-nav-1-active.png',
          bgImageUrlMobile:
            'https://cdn-game-activity.23you.net/frontend/ddj-official-vietnam/assets/article-nav-1--mobile.png',
          bgImageActiveUrlMobile:
            'https://cdn-game-activity.23you.net/frontend/ddj-official-vietnam/assets/article-nav-1-active--mobile.png',
          id: null,
        },
        {
          label: '事件',
          value: 'Sự Kiện',
          bgImageUrl:
            'https://cdn-game-activity.23you.net/frontend/ddj-official-vietnam/assets/article-nav-2.png',
          bgImageActiveUrl:
            'https://cdn-game-activity.23you.net/frontend/ddj-official-vietnam/assets/article-nav-2-active.png',
          bgImageUrlMobile:
            'https://cdn-game-activity.23you.net/frontend/ddj-official-vietnam/assets/article-nav-2--mobile.png',
          bgImageActiveUrlMobile:
            'https://cdn-game-activity.23you.net/frontend/ddj-official-vietnam/assets/article-nav-2-active--mobile.png',
        },
        {
          label: '引导',
          value: 'Hướng Dẫn',
          bgImageUrl:
            'https://cdn-game-activity.23you.net/frontend/ddj-official-vietnam/assets/article-nav-3.png',
          bgImageActiveUrl:
            'https://cdn-game-activity.23you.net/frontend/ddj-official-vietnam/assets/article-nav-3-active.png',
          bgImageUrlMobile:
            'https://cdn-game-activity.23you.net/frontend/ddj-official-vietnam/assets/article-nav-3--mobile.png',
          bgImageActiveUrlMobile:
            'https://cdn-game-activity.23you.net/frontend/ddj-official-vietnam/assets/article-nav-3-active--mobile.png',
        },
        {
          label: '综合',
          value: 'Cộng Đồng',
          bgImageUrl:
            'https://cdn-game-activity.23you.net/frontend/ddj-official-vietnam/assets/article-nav-4.png',
          bgImageActiveUrl:
            'https://cdn-game-activity.23you.net/frontend/ddj-official-vietnam/assets/article-nav-4-active.png',
          bgImageUrlMobile:
            'https://cdn-game-activity.23you.net/frontend/ddj-official-vietnam/assets/article-nav-4--mobile.png',
          bgImageActiveUrlMobile:
            'https://cdn-game-activity.23you.net/frontend/ddj-official-vietnam/assets/article-nav-4-active--mobile.png',
        },
      ],
      active_item_id: null,
      swiperImages: [],
      newsData: [],
      bottomNavList: [],
    };
  },
  mounted() {
    getAd({
      gameCode: 'ddj-vn',
      adPlace: 'news',
    }).then((res) => {
      const list = res.data ?? [];
      this.swiperImages = list;
      this.$nextTick(() => {
        new this.$Swiper('.news-swiper-container', {
          loop: true,
          speed: 500,
          // 如果需要分页器
          pagination: {
            el: '.swiper-pagination',
            clickable: true, // 允许点击小圆点跳转
          },
          //如果需要自动切换海报
          autoplay: {
            delay: 1000,
            disableOnInteraction: false, // 手动切换之后继续自动轮播
          },
        });
      });
    });
    this.fetchArticleList();
    this.fetchArticleClassList();
    this.fetchBottomNavList();
  },

  filters: {
    formatTime: function (value) {
      if (!value) return '';
      return value.slice(0, 10).replace(/-/g, '.');
    },
  },

  methods: {
    jumpLink(path, item) {
      if (path.includes('detail')) {
        let articleId = item.articleId;
        this.$router.push({ path, query: { id: articleId } });
      } else {
        this.$router.push(path);
      }
    },

    changeItem(id) {
      this.active_item_id = id;
      this.fetchArticleList(id);
    },

    handleClickSwiperImage(link) {
      if (link) {
        jumpUrlNewWindow(link);
      }
    },

    handleClickBottomNav(link, index) {
      if (link) {
        if (index === 3) {
          jumpUrlNewWindow(link);
          return;
        }
        window.location.href = link;
      }
    },

    async fetchArticleList(articleClass = null) {
      const res = await getArticle({
        gameCode: 'ddj-vn',
        articleClass,
        size: 5,
        current: 1,
      });
      const records = res.data?.records ?? [];
      this.newsData = records;
    },

    async fetchArticleClassList() {
      const res = await getArticleClass({
        gameCode: 'ddj-vn',
        parentId: 0,
      });
      const records = res?.data ?? [];
      if (records.length === 0) return;
      this.bottomItems = this.bottomItems.map((el, index) =>
        index > 0
          ? {
              ...el,
              id: records[index - 1]['id'],
            }
          : el,
      );
    },

    async fetchBottomNavList() {
      const res = await getAd({
        gameCode: 'ddj-vn',
        adPlace: 'news_bottom',
      });
      const list = res.data ?? [];
      this.bottomNavList = list;
    },
  },
};
</script>
<style scoped lang="scss" src="./scss/news.scss"></style>